import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { BuildingInsuranceTypeSelectFormikField } from '../../../BuildingInsuranceTypeSelectFormikField'

import { BUILDING_FORM_INSURANCE_TYPE_API_PARAMS } from './InsuranceTypeField.constants'

function InsuranceTypeField({ name }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <BuildingInsuranceTypeSelectFormikField
      apiParams={BUILDING_FORM_INSURANCE_TYPE_API_PARAMS}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Building.InsuranceTypePlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Building.InsuranceTypeLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={name}
    />
  )
}

export default InsuranceTypeField
